import { render, staticRenderFns } from "./MemberListCuratorLayout.vue?vue&type=template&id=0986b484&scoped=true&"
import script from "./MemberListCuratorLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListCuratorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0986b484",
  null
  
)

export default component.exports